module.exports = __webpack_public_path__ + "static/img/about-bg.751bac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/about-bg.png
// module id = Qx8K
// module chunks = 184